import { createClient } from "@supabase/supabase-js";
const supabaseUrl = "https://sjevrkuajehqekpzuwcp.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNqZXZya3VhamVocWVrcHp1d2NwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDE2OTU3NDgsImV4cCI6MjAxNzI3MTc0OH0.z_LXQCYQRYZaKtxkWDFphRUIOaxmI0z1cskvhswCH84";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
